import { Module } from "vuex";
import * as firebase from "firebase/app";
import "firebase/firestore";
import moment from "moment";
import { localizedDate } from "@/utils/localizedDate";

const homeMessagesModule: Module<any, any> = {
  namespaced: false,
  state: {
    homeChatMessages: [],
  },
  mutations: {
    setHomeChatMessages(state: any, payload: []) {
      state.homeChatMessages = payload;
    },
  },
  actions: {
    async getHomeChatMessages({ commit }, { channel, facilityId }) {
      const query = firebase
        .firestore()
        .collection('homeChatsMessage')
        .where('facilityId', '==', facilityId)
        .where('channel', '==', channel)
        .orderBy('createdAt');

      const querySnapshot = await query.get();
      const resList = querySnapshot.docs.map(doc => {
        const data = doc.data();
        data.id = doc.id;
        data.createdAtDisplay = moment(data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt).isSame(moment(), 'day')
          ? localizedDate(
              data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
              this.state.authModule.currentFacilityData.timeFormat
            )
          : localizedDate(data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt);

        // Map to user object for ChatPanel compatibility
        data.user = {
          id: data.senderId || '',
          firstName: data.senderName || '',
          profileImage: data.senderPhotoUrl || '',
        };

        return data;
      });

      commit('setHomeChatMessages', resList);
      return resList;
    },

    async createHomeChatMessage({ dispatch }, data) {
      try {
        data.facilityId = this.state.authModule.currentFacility;
        data.createdAt = firebase.firestore.Timestamp.fromDate(new Date());
        const res = await firebase.firestore().collection('homeChatsMessage').add(data);
        data.id = res.id;
        return data;
      } catch (error) {
        console.error(error);
        return null;
      }
    },

    async readHomeChatMessages({ commit }, { channel, facilityId }) {
      try {
        const snap = await firebase
          .firestore()
          .collection('homeChatsMessage')
          .where('facilityId', '==', facilityId)
          .where('channel', '==', channel)
          .where('senderRole', '==', 'family')
          .where('read', '==', false)
          .get();

        const batch = firebase.firestore().batch();
        snap.docs.forEach(doc => {
          batch.update(doc.ref, { read: true, readDateTime: firebase.firestore.Timestamp.fromDate(new Date()) });
        });
        await batch.commit();

        // Update homeChats lastMessage.read
        const chatSnap = await firebase.firestore().collection('homeChats')
          .where('facilityId', '==', facilityId)
          .where('channel', '==', channel)
          .limit(1)
          .get();

        if (!chatSnap.empty) {
          await chatSnap.docs[0].ref.update({
            'lastMessage.read': true,
            'lastMessage.readDateTime': firebase.firestore.Timestamp.fromDate(new Date()),
            'unreadMessagesFromFamilyMember': 0,
          });
        }

        return true;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
  },
};

export default homeMessagesModule;
